var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 142,
    viewBox: "0 0 201 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "LC_Bucharest_white(2) copy 1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.5016 98.3139H39.3558V110.663H43.5366V113.399H36.5016V98.3139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.5362 100.969L57.5262 102.9C56.1594 101.452 54.6318 100.727 52.9434 100.727C51.4962 100.727 50.2902 101.21 49.3254 102.216C48.3204 103.181 47.838 104.428 47.838 105.836C47.838 106.842 48.039 107.727 48.4812 108.531C48.9234 109.296 49.5264 109.939 50.3304 110.382C51.1344 110.824 52.0188 111.066 52.9836 111.066C53.8278 111.066 54.5916 110.905 55.275 110.583C55.9584 110.261 56.7222 109.698 57.5262 108.893L59.4558 110.905C58.3302 111.991 57.285 112.755 56.3202 113.158C55.3554 113.56 54.1896 113.801 52.9434 113.801C50.6118 113.801 48.6822 113.077 47.1948 111.589C45.7074 110.1 44.9436 108.21 44.9436 105.876C44.9436 104.388 45.2652 103.02 45.9486 101.854C46.632 100.687 47.5968 99.762 48.8832 99.038C50.1294 98.3139 51.4962 97.9921 52.9836 97.9921C54.2298 97.9921 55.4358 98.2737 56.5614 98.7966C57.7272 99.2391 58.7322 100.003 59.5362 100.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M67.8978 113.399V98.3139H70.2696C71.6364 98.3139 72.6414 98.3943 73.2846 98.5955C74.169 98.8368 74.8926 99.2793 75.4554 99.9229C76.0182 100.567 76.2594 101.331 76.2594 102.216C76.2594 102.779 76.1388 103.302 75.8976 103.785C75.6564 104.267 75.2544 104.71 74.7318 105.112C75.6564 105.555 76.2996 106.078 76.7418 106.721C77.184 107.365 77.385 108.129 77.385 109.014C77.385 109.859 77.184 110.623 76.7418 111.347C76.2996 112.031 75.7368 112.554 75.0534 112.916C74.37 113.278 73.4052 113.439 72.1992 113.439H67.8978V113.399ZM70.7922 101.049V104.227H71.4354C72.1188 104.227 72.6414 104.066 73.0032 103.785C73.3248 103.503 73.5258 103.101 73.5258 102.578C73.5258 102.095 73.365 101.733 73.0434 101.452C72.7218 101.17 72.2394 101.049 71.556 101.049H70.7922ZM70.7922 106.802V110.663H71.5158C72.7218 110.663 73.5258 110.503 73.9278 110.221C74.3298 109.939 74.5308 109.497 74.5308 108.893C74.5308 108.25 74.2896 107.727 73.8072 107.365C73.3248 107.003 72.5208 106.802 71.3952 106.802H70.7922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M79.7567 102.256H82.5707V107.606C82.5707 108.652 82.6511 109.376 82.7717 109.778C82.9325 110.181 83.1335 110.503 83.4551 110.744C83.7767 110.985 84.1788 111.066 84.621 111.066C85.0632 111.066 85.4651 110.945 85.7867 110.744C86.1083 110.503 86.3495 110.181 86.5103 109.778C86.6309 109.457 86.6711 108.773 86.6711 107.727V102.256H89.4851V106.963C89.4851 108.893 89.3243 110.221 89.0429 110.945C88.6811 111.83 88.1183 112.474 87.3947 112.956C86.6711 113.439 85.7466 113.64 84.621 113.64C83.415 113.64 82.4099 113.359 81.6461 112.836C80.8823 112.273 80.3597 111.548 80.0381 110.543C79.8371 109.859 79.7166 108.652 79.7166 106.842V102.256H79.7567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M103.234 104.509L100.902 105.796C100.46 105.354 100.018 105.032 99.6155 104.831C99.1733 104.67 98.6909 104.549 98.1281 104.549C97.0829 104.549 96.2387 104.871 95.5955 105.474C94.9523 106.118 94.6307 106.882 94.6307 107.888C94.6307 108.853 94.9523 109.618 95.5553 110.221C96.1583 110.824 97.0025 111.106 98.0075 111.106C99.2537 111.106 100.219 110.663 100.942 109.819L103.153 111.347C101.947 112.916 100.259 113.68 98.0879 113.68C96.1181 113.68 94.5905 113.117 93.5051 111.951C92.3795 110.784 91.8569 109.416 91.8569 107.888C91.8569 106.802 92.1383 105.796 92.6609 104.911C93.1835 103.986 93.9473 103.302 94.9121 102.779C95.8769 102.256 96.9623 102.015 98.1683 102.015C99.2939 102.015 100.259 102.216 101.143 102.658C102.028 103.101 102.671 103.664 103.234 104.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M105.766 97.9518H108.54V103.382C109.103 102.9 109.625 102.578 110.188 102.337C110.751 102.095 111.314 101.975 111.877 101.975C113.002 101.975 113.927 102.377 114.691 103.141C115.334 103.785 115.655 104.79 115.655 106.078V113.439H112.922V108.572C112.922 107.284 112.841 106.399 112.721 105.957C112.6 105.514 112.399 105.152 112.078 104.951C111.796 104.71 111.394 104.629 110.992 104.629C110.429 104.629 109.947 104.831 109.545 105.193C109.143 105.555 108.862 106.078 108.701 106.721C108.62 107.043 108.58 107.807 108.58 109.014V113.479H105.806V97.9518H105.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M126.55 102.256H129.364V113.399H126.55V112.232C125.987 112.755 125.464 113.117 124.901 113.359C124.339 113.6 123.776 113.721 123.133 113.721C121.685 113.721 120.439 113.158 119.394 112.031C118.349 110.905 117.826 109.537 117.826 107.888C117.826 106.158 118.349 104.75 119.354 103.664C120.359 102.578 121.605 102.015 123.052 102.015C123.736 102.015 124.339 102.135 124.942 102.377C125.545 102.618 126.067 103.02 126.55 103.503V102.256ZM123.615 104.549C122.771 104.549 122.047 104.871 121.444 105.474C120.881 106.078 120.6 106.882 120.6 107.807C120.6 108.773 120.881 109.577 121.484 110.181C122.047 110.784 122.771 111.106 123.615 111.106C124.499 111.106 125.223 110.784 125.786 110.181C126.349 109.577 126.67 108.773 126.67 107.767C126.67 106.802 126.389 105.997 125.786 105.394C125.223 104.831 124.499 104.549 123.615 104.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M131.534 102.256H133.946V103.664C134.188 103.101 134.549 102.699 134.992 102.417C135.434 102.135 135.876 101.974 136.399 101.974C136.76 101.974 137.122 102.055 137.524 102.256L136.64 104.67C136.318 104.509 136.037 104.428 135.836 104.428C135.394 104.428 135.032 104.71 134.75 105.233C134.469 105.756 134.308 106.802 134.308 108.371V108.893V113.399H131.534V102.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M150.026 108.612H141.062C141.182 109.416 141.544 110.02 142.107 110.503C142.67 110.985 143.393 111.186 144.278 111.186C145.323 111.186 146.207 110.824 146.971 110.1L149.343 111.186C148.74 112.031 148.057 112.635 147.253 113.037C146.449 113.439 145.444 113.64 144.318 113.64C142.589 113.64 141.142 113.077 140.057 111.991C138.971 110.905 138.409 109.497 138.409 107.848C138.409 106.158 138.971 104.75 140.057 103.624C141.142 102.497 142.509 101.934 144.157 101.934C145.926 101.934 147.333 102.497 148.418 103.624C149.504 104.75 150.067 106.239 150.067 108.089L150.026 108.612ZM147.253 106.399C147.052 105.796 146.69 105.273 146.167 104.871C145.604 104.469 145.001 104.267 144.278 104.267C143.514 104.267 142.831 104.469 142.228 104.911C141.866 105.193 141.504 105.675 141.182 106.359H147.253V106.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M159.112 103.785L157.383 105.514C156.7 104.831 156.056 104.469 155.453 104.469C155.132 104.469 154.891 104.549 154.73 104.67C154.569 104.79 154.448 104.951 154.448 105.152C154.448 105.313 154.489 105.434 154.609 105.555C154.73 105.675 155.011 105.836 155.453 106.078L156.458 106.601C157.544 107.123 158.267 107.687 158.669 108.21C159.071 108.773 159.272 109.416 159.272 110.141C159.272 111.146 158.911 111.951 158.187 112.635C157.463 113.278 156.499 113.64 155.252 113.64C153.644 113.64 152.318 112.997 151.353 111.75L153.082 109.859C153.403 110.261 153.805 110.543 154.247 110.784C154.69 111.025 155.092 111.146 155.413 111.146C155.775 111.146 156.097 111.066 156.298 110.865C156.539 110.704 156.619 110.462 156.619 110.261C156.619 109.819 156.217 109.416 155.413 109.014L154.489 108.531C152.68 107.606 151.795 106.48 151.795 105.112C151.795 104.227 152.117 103.463 152.8 102.859C153.484 102.216 154.328 101.934 155.413 101.934C156.137 101.934 156.82 102.095 157.463 102.417C158.107 102.739 158.669 103.222 159.112 103.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M161.845 98.153H164.659V102.256H166.307V104.67H164.659V113.399H161.845V104.629H160.398V102.216H161.845V98.153Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 149,
    height: 65
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000158709779541082052280000005648550347942945928_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M174.669 28.9632H26.532V92.9637H174.669V28.9632Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M76.0986 62.1099C74.8926 58.1677 71.2344 55.2714 66.8526 55.2714C62.511 55.2714 58.8528 58.1677 57.6468 62.0697L76.0986 62.1099ZM57.2448 64.8856C57.2448 70.1955 61.5462 74.4997 66.8928 74.4997C69.747 74.4997 72.3198 73.2527 74.0886 71.2816H78.0282C75.8172 75.1031 71.6364 77.6776 66.8928 77.6776C59.7774 77.6776 54.0288 71.9252 54.0288 64.8453C54.0288 57.7654 59.7774 52.013 66.8928 52.013C74.0082 52.013 79.7568 57.7654 79.7568 64.8453L57.2448 64.8856Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1358_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 149,
    height: 65
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000039111297975248655490000012431024538303630727_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M174.669 28.9632H26.532V92.9637H174.669V28.9632Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1358_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M48.6018 62.1099C47.3958 58.1677 43.7376 55.2714 39.3558 55.2714C35.0142 55.2714 31.356 58.1677 30.15 62.0697L48.6018 62.1099ZM29.7078 64.8856C29.7078 70.1955 34.0092 74.4997 39.3558 74.4997C42.21 74.4997 44.7828 73.2527 46.5516 71.2816H50.4912C48.2802 75.1031 44.0994 77.6776 39.3558 77.6776C32.2404 77.6776 26.4918 71.9252 26.4918 64.8453C26.4918 57.7654 32.2404 52.013 39.3558 52.013C46.4712 52.013 52.2198 57.7654 52.2198 64.8453L29.7078 64.8856Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1358_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 149,
    height: 65
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000178892941097032823830000007137572285965848247_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M174.669 28.9632H26.532V92.9637H174.669V28.9632Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1358_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M145.202 62.1099C143.996 58.1677 140.338 55.2714 135.956 55.2714C131.615 55.2714 127.957 58.1677 126.751 62.0697L145.202 62.1099ZM126.308 64.8856C126.308 70.1955 130.65 74.4997 135.956 74.4997C138.811 74.4997 141.383 73.2527 143.152 71.2816H147.092C144.881 75.1031 140.7 77.6776 135.956 77.6776C128.841 77.6776 123.092 71.9252 123.092 64.8453C123.092 57.7654 128.841 52.013 135.956 52.013C143.072 52.013 148.82 57.7654 148.82 64.8453L126.308 64.8856Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1358_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 149,
    height: 65
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000054245307362643868370000004371747507126997406_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M174.669 28.9632H26.532V92.9637H174.669V28.9632Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1358_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M111.676 71.3218C111.676 73.132 113.123 74.6204 114.932 74.6204C118.59 74.6204 121.726 73.5745 122.61 72.2068L124.459 74.3388C122.61 76.3501 119.032 77.6776 114.892 77.6776C111.354 77.6776 108.46 74.8215 108.46 71.3218V55.3518H99.3744V52.0935H108.46V39.2612H111.676V52.0532H116.62V55.3116H111.676V71.3218Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1358_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 149,
    height: 65
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000150822472576124505480000003003032157202836119_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M174.669 28.9632H26.532V92.9637H174.669V28.9632Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1358_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M150.589 64.8855C150.589 57.8057 156.338 52.0533 163.453 52.0533C168.197 52.0533 172.378 54.6278 174.629 58.5297H170.689C168.88 56.5184 166.307 55.2714 163.453 55.2714C158.147 55.2714 153.805 59.5756 153.805 64.8855V64.9258C153.805 70.2357 158.107 74.5399 163.453 74.5399C166.307 74.5399 168.88 73.2929 170.649 71.3218H174.589C172.378 75.1433 168.197 77.7178 163.453 77.7178C156.338 77.7178 150.589 72.0057 150.589 64.8855Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1358_326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 28,
    width: 149,
    height: 65
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000127733541186866282480000017467172528531467660_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M174.669 28.9632H26.532V92.9637H174.669V28.9632Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1358_326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M87.1134 92.9637C88.5606 91.7569 90.1284 90.5904 91.6962 89.4238C97.6056 84.9586 103.756 80.3728 103.756 74.6204C103.756 68.9082 97.6458 64.3224 91.7364 59.8572C86.3496 55.8345 80.802 51.651 80.802 47.3065C80.802 43.0023 86.3496 38.8187 91.6962 34.796C94.2288 32.9054 96.7614 30.9745 98.892 28.9632H94.7112C93.264 30.17 91.656 31.3768 90.048 32.5836C84.1386 37.0085 78.0282 41.5943 78.0282 47.3467C78.0282 53.0991 84.1386 57.685 90.0882 62.1501C95.4348 66.1728 100.982 70.3564 100.982 74.6606C100.982 79.0051 95.4348 83.1484 90.048 87.2113C87.5556 89.102 84.9828 90.9926 82.8924 93.004L87.1134 92.9637Z",
    fill: "white"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.70daeaa09e08da959056a265f9b7c479.svg";
export { ForwardRef as ReactComponent };